/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ProductsInputs */



/**
* | output |
* | --- |
* | "Products" |
*
* @param {Nav_ProductsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_products = /** @type {((inputs?: Nav_ProductsInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ProductsInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Produkte")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Produits")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("产品")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("商品")
	if (locale === "ko") return /** @type {LocalizedString} */ ("제품")
	return /** @type {LocalizedString} */ ("Products")
});